import React from "react";
import { Alert, Col, Row } from "reactstrap";

// labels
import { LB_DATE, LB_HOTEL, LB_NAME, LB_STATUS, } from "../../i18n/i18n";

const ItineraryComponent = ({itinerary}) => <div className={'wl-modal-content'}>
        {
            itinerary?.status === false && <Alert color="danger">
                {itinerary?.message}
            </Alert>
        }
        {
            itinerary?.data &&  <>
                <Row className={'wl-modal-labels'}>
                    <Col sm={4}>{LB_NAME}</Col>
                    <Col sm={2}>{LB_DATE}</Col>
                    <Col sm={3}>{LB_HOTEL}</Col>
                    <Col sm={3}>{LB_STATUS}</Col>
                </Row>
                <Row className={'wl-modal-info'}>
                    <Col sm={4}>{itinerary?.data.traveler?.name}</Col>
                    <Col sm={2}>{itinerary?.data?.reservation?.chekIn}</Col>
                    <Col sm={3}>{itinerary?.data?.reservation?.hotel}</Col>
                    <Col sm={3}>
                        {/*{
                            itinerary?.data?.additionalInfo?.messages.length > 0 ? itinerary?.data?.additionalInfo?.messages.map( (m,i) => <label key={`alert-${i}`} className={'text-danger'}>
                                {m}
                            </label>)
                                : <label key={`alert`} className={'text-ok'}>
                                    OK
                                </label>
                        }*/}

                        <label key={`alert`} className={'text-ok'}>
                            OK
                        </label>
                    </Col>
                </Row>
            </>
        }
    </div>

export default ItineraryComponent